import React from "react";
import ReactDOM from "react-dom/client";
import HttpApi from "i18next-http-backend";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    supportedLngs: ["jp", "en", "pl", "de"],
    lng: "en",
    fallbackLng: "en",
    defaultNS: "translation",
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
  });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
